const stock = {
  LIST_SUFFIX: 'stock/list',
  DETAIL_SUFFIX: 'stock/details',
};

export default stock;
